export default "__VITE_ASSET__DIkCXDGE__"